<script setup lang="ts">
  import { ApprovalTable } from '@/pages/approval';
  import ApprovalListView from './ApprovalListView.vue';
</script>

<template>
  <ApprovalListView :table-component="ApprovalTable" />
</template>
